export default "__VITE_ASSET__D38P41wQ__"